import { LazyCodeEditor } from "@/components/storyboard/code/LazyCodeEditor";
import CodeCopyButton from "@/components/storyboard/code/CodeCopyButton";

interface CodeQuizEditorProps {
  /** Heading in the dark pane, e.g. "Dein Code". */
  label: string;
  value: string;
  onChange: (value: string) => void;
  language?: string;
  readOnly?: boolean;
}

/**
 * Dark editor pane for a code quiz: the learner's code, with the same
 * top-right copy control as an inline code example.
 */
const CodeQuizEditor = ({
  label,
  value,
  onChange,
  language,
  readOnly = false,
}: CodeQuizEditorProps) => (
  <div className="flex h-full flex-col overflow-hidden rounded-xl bg-gray-700">
    <div className="flex shrink-0 items-center justify-between gap-2 px-4 py-2">
      <span className="font-semibold uppercase tracking-wide text-gray-300">
        {label}
      </span>
      <CodeCopyButton code={value} placement="inline" />
    </div>
    <div className="min-h-0 flex-1 p-3 pt-0">
      <LazyCodeEditor
        fill
        value={value}
        onChange={onChange}
        language={language}
        readOnly={readOnly}
      />
    </div>
  </div>
);

export default CodeQuizEditor;
